//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfNotification from "~/themes/fiskarsMoominDefault/components/components/molecules/SfNotification/SfNotification.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import { useUiNotification } from '~/composables';

export default {
  name: 'Notification',
  components: {
    SfNotification,
    SfIcon
  },
  setup () {
    const { notifications } = useUiNotification();

    const handleActionClick = (action, dismiss) => {
      action?.onClick();
      dismiss();
    };

    return {
      notifications,
      handleActionClick
    };
  }
};
